// (function($) {

//   // Watch the scrolling and show the scroll up button when needed
//   var button  = $('.to-top'),
//   view = $(window),
//   scrollOffset = 100,
//   timeoutKey = -1;

//   view.scroll(function() {
//     if (timeoutKey) { window.clearTimeout(timeoutKey); }

//     timeoutKey = window.setTimeout(function(){
//       if (view.scrollTop() > scrollOffset) {
//         button.addClass('show');
//       } else {
//         button.removeClass('show');
//       }
//     }, 100);
//   });

// })(jQuery);
